(() => {
  'use strict';

  const formatMoney = (cents) => {
    const format = (window.RedClayTheme && window.RedClayTheme.moneyFormat) || '${{amount}}';
    const value = (Number(cents || 0) / 100).toFixed(2);
    const commaValue = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/{{\s*amount\s*}}/g, commaValue)
      .replace(/{{\s*amount_no_decimals\s*}}/g, String(Math.round(Number(cents || 0) / 100)))
      .replace(/{{\s*amount_with_comma_separator\s*}}/g, value.replace('.', ','));
  };

  const setMenu = (open) => {
    const menu = document.querySelector('[data-mobile-nav]');
    const toggle = document.querySelector('[data-menu-toggle]');
    if (!menu || !toggle) return;
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', String(!open));
    toggle.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('nav-open', open);
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-menu-toggle]')) setMenu(true);
    if (event.target.closest('[data-menu-close]')) setMenu(false);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setMenu(false);
  });

  const sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.assign(url.toString());
    });
  }

  document.querySelectorAll('[data-quantity-input]').forEach((input) => {
    const container = input.closest('.quantity-input');
    if (!container) return;
    const down = container.querySelector('[data-quantity-minus]');
    const up = container.querySelector('[data-quantity-plus]');
    if (down) down.addEventListener('click', () => { input.value = Math.max(1, Number(input.value || 1) - 1); input.dispatchEvent(new Event('change', { bubbles: true })); });
    if (up) up.addEventListener('click', () => { input.value = Number(input.value || 1) + 1; input.dispatchEvent(new Event('change', { bubbles: true })); });
  });

  document.querySelectorAll('[data-product]').forEach((productRoot) => {
    const productJSON = productRoot.querySelector('[data-product-json]');
    const form = productRoot.querySelector('[data-product-form]');
    if (!productJSON || !form) return;

    let product;
    try { product = JSON.parse(productJSON.textContent); } catch (error) { return; }
    const optionInputs = [...form.querySelectorAll('[data-variant-select]')];
    const variantId = form.querySelector('[data-variant-id]');
    const fallbackSelect = form.querySelector('[data-variant-fallback]');
    const addButton = form.querySelector('[data-add-to-cart]');
    const addLabel = form.querySelector('[data-add-label]');
    const status = form.querySelector('[data-variant-status]');
    const price = productRoot.querySelector('[data-product-price]');
    const requiresSellingPlan = form.dataset.requiresSellingPlan === 'true';

    if (variantId) variantId.disabled = false;
    if (fallbackSelect) fallbackSelect.disabled = true;

    const showMedia = (mediaId) => {
      if (!mediaId) return;
      productRoot.querySelectorAll('[data-media-id]').forEach((item) => item.classList.toggle('is-active', String(item.dataset.mediaId) === String(mediaId)));
      productRoot.querySelectorAll('[data-media-thumb]').forEach((item) => item.classList.toggle('is-active', String(item.dataset.mediaThumb) === String(mediaId)));
    };

    productRoot.querySelectorAll('[data-media-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => showMedia(thumb.dataset.mediaThumb));
    });

    const updatePrice = (variant) => {
      if (!price) return;
      let output = `<div class="price${variant.compare_at_price > variant.price ? ' price--sale' : ''}"><span>${formatMoney(variant.price)}</span>`;
      if (variant.compare_at_price > variant.price) output += `<s>${formatMoney(variant.compare_at_price)}</s>`;
      output += '</div>';
      price.innerHTML = output;
    };

    const updateVariant = () => {
      const selected = optionInputs.map((input) => input.value);
      const variant = product.variants.find((item) => item.options.every((option, index) => option === selected[index]));
      if (!variant) {
        if (variantId) variantId.value = '';
        if (addButton) addButton.disabled = true;
        if (addLabel) addLabel.textContent = 'Unavailable';
        if (status) status.textContent = 'This combination is unavailable.';
        return;
      }
      if (variantId) variantId.value = variant.id;
      if (addButton) addButton.disabled = requiresSellingPlan || !variant.available;
      if (addLabel) addLabel.textContent = requiresSellingPlan ? 'Selling plan required' : (variant.available ? 'Add to cart' : 'Sold out');
      if (status) status.textContent = requiresSellingPlan ? 'This product requires a selling plan before it can be added to cart.' : (variant.available ? '' : 'Sold out');
      updatePrice(variant);
      if (variant.featured_media && variant.featured_media.id) showMedia(variant.featured_media.id);
      optionInputs.forEach((input) => {
        const optionLabel = input.closest('.product-form__option')?.querySelector('[data-option-value]');
        if (optionLabel) optionLabel.textContent = input.value;
      });
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    optionInputs.forEach((input) => input.addEventListener('change', updateVariant));
  });
})();
